import { useEffect, useState } from 'react';
import { useMediaQuery, styled } from '@mui/material';
import { StyledTablePagination, variables } from '../common';
import { pathOr, always } from 'rambda';
import { flow } from 'fp-ts/function';
import { RequestStatus2d, properties, useLegacyRequestSearch } from '.';

const rowsPerPageOptions = [10, 25, 50, 100, 500];

export const LegacyStatus = () => {
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const handleChangePage = (_: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = flow(
    pathOr('10', 'target.value'),
    (a: string) => parseInt(a, 10),
    setPageSize,
    always(0),
    setPage
  );

  const { requestStatus, call, search } = useLegacyRequestSearch({
    page,
    pageSize,
  });

  useEffect(search, [page, pageSize, search]);

  const matchesGridBreakpoint = useMediaQuery('(min-width:60em)', {
    noSsr: true,
  });

  return (
    <Article>
      {matchesGridBreakpoint && (
        <>
          {requestStatus.total > pageSize && (
            <div style={{ display: 'flex', justifyContent: 'right' }}>
              <StyledTablePagination
                rowsPerPageOptions={rowsPerPageOptions}
                count={requestStatus.total}
                rowsPerPage={pageSize}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </div>
          )}
        </>
      )}

      <RequestStatus2d
        properties={properties}
        requests={requestStatus.content}
        getRequstsCallStatus={call}
      />

      {requestStatus.total > pageSize && (
        <StyledTablePagination
          rowsPerPageOptions={rowsPerPageOptions}
          count={requestStatus.total}
          rowsPerPage={pageSize}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      )}
    </Article>
  );
};

const Article = styled('article')(({ theme }) => ({
  ...variables.childrenMarginTop2x,
}));
